module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"widgetExpired":{"description":"The Compliance subscription has expired. To continue staying compliant please contact the support team <b><a href = \u0027mailto: support@nationbetter.uk\u0027>support@nationbetter.uk</a></b>"}}}')
  delete Component.options._Ctor
}
